import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { LayoutService } from './layout.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit, OnDestroy {
  public isLoading: boolean = false;

  public language: string = 'en';

  private _unsubscribe: Subject<any> = new Subject<any>();

  constructor(private router: Router, private layoutService: LayoutService, private title: Title, private cd: ChangeDetectorRef) {
    this.router.events.pipe(takeUntil(this._unsubscribe)).subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const url = event.url.split('/')[1];
        this.setTitle(url);
      }
    });

    this.layoutService.loading$.pipe(takeUntil(this._unsubscribe)).subscribe(loading => {
      this.isLoading = loading;
      this.cd.markForCheck();
    });
  }

  // -----------------------------------------------------------------------------------------------------
  //  @ Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this._unsubscribe.next(null);
    this._unsubscribe.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  private setTitle(url: string): void {
    if (url === 'login') {
      this.title.setTitle('Please log in to use ZAMMY. - ZAMMY SSO Service');
    } else {
      this.title.setTitle('ZAMMY Single Sign-On Service');
    }

    this.cd.markForCheck();
  }
}
